"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.translations = exports.getTranslatedDropdownItems = exports.getTranslation = void 0;
var tslib_1 = require("tslib");
var merge_1 = tslib_1.__importDefault(require("lodash/merge"));
var util_1 = require("@gooddata/util");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var en_US_json_1 = tslib_1.__importDefault(require("../translations/en-US.json"));
var de_DE_json_1 = tslib_1.__importDefault(require("../translations/de-DE.json"));
var es_ES_json_1 = tslib_1.__importDefault(require("../translations/es-ES.json"));
var fr_FR_json_1 = tslib_1.__importDefault(require("../translations/fr-FR.json"));
var ja_JP_json_1 = tslib_1.__importDefault(require("../translations/ja-JP.json"));
var nl_NL_json_1 = tslib_1.__importDefault(require("../translations/nl-NL.json"));
var pt_BR_json_1 = tslib_1.__importDefault(require("../translations/pt-BR.json"));
var pt_PT_json_1 = tslib_1.__importDefault(require("../translations/pt-PT.json"));
var zh_Hans_json_1 = tslib_1.__importDefault(require("../translations/zh-Hans.json"));
var ru_RU_json_1 = tslib_1.__importDefault(require("../translations/ru-RU.json"));
function getTranslation(translationId, intl, values) {
    if (values === void 0) { values = {}; }
    return intl ? intl.formatMessage({ id: translationId }, values) : translationId;
}
exports.getTranslation = getTranslation;
function getTranslatedDropdownItems(dropdownItems, intl) {
    return dropdownItems.map(function (item) {
        var translatedTitleProp = item.title ? { title: getTranslation(item.title, intl) } : {};
        var translatedInfoProp = item.info ? { info: getTranslation(item.info, intl) } : {};
        return tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, item), translatedTitleProp), translatedInfoProp);
    });
}
exports.getTranslatedDropdownItems = getTranslatedDropdownItems;
var sdkUiExtTranslations = {
    "en-US": util_1.translationUtils.removeMetadata(en_US_json_1.default),
    "de-DE": de_DE_json_1.default,
    "es-ES": es_ES_json_1.default,
    "fr-FR": fr_FR_json_1.default,
    "ja-JP": ja_JP_json_1.default,
    "nl-NL": nl_NL_json_1.default,
    "pt-BR": pt_BR_json_1.default,
    "pt-PT": pt_PT_json_1.default,
    "zh-Hans": zh_Hans_json_1.default,
    "ru-RU": ru_RU_json_1.default,
};
/**
 * @internal
 */
exports.translations = merge_1.default(sdk_ui_1.messagesMap, // we use also some of the sdk-ui strings here so we need to merge them in here
sdkUiExtTranslations);
//# sourceMappingURL=translations.js.map